import dayjs, { type Dayjs } from 'dayjs';
import type { Location } from 'react-router';

/**
 * «Open this накладная, then bring me back HERE» — the jadval a document was
 * tapped from. Carried in router state (not the URL) so a reload or a shared
 * link of the накладная page still falls back to the plain shipments list.
 */
export interface ReturnToState {
  returnTo?: string;
}

/** The in-app path to return to after the накладная screen, if one was given. */
export function returnToOf(location: Location): string | null {
  const state = location.state as ReturnToState | null;
  const to = state?.returnTo;
  return typeof to === 'string' && to.startsWith('/') && !to.startsWith('//') ? to : null;
}

/** The jadval's own return address: this page, pinned to the month on screen. */
export function jadvalReturnTo(pathname: string, month: string): string {
  return `${pathname}?month=${month}&view=grid`;
}

/** Initial month for a monthly page: `?month=YYYY-MM` when valid, else now. */
export function monthFromSearch(search: string): Dayjs {
  const raw = new URLSearchParams(search).get('month');
  const parsed = raw && /^\d{4}-\d{2}$/.test(raw) ? dayjs(raw, 'YYYY-MM', true) : null;
  return (parsed?.isValid() ? parsed : dayjs()).startOf('month');
}
